<template>
  <v-main>
   <div class="override-class" style="{ margin: '20px'}">
            <v-row>
              <v-col col="12">
            <img style="max-width: 1000px; height: auto;" src="../assets/logo.png"/>
                <h1>Graphical user interface to query <i>MetaflammDB</i> for stored metadata. </h1>
                <p>Learn more about by navigating to either the help <a href="/help">
                  <v-icon> mdi-help-box-multiple</v-icon></a> content</p> <p> or documentation
                  <a href="/documentation"><v-icon>mdi-text-box-multiple</v-icon></a>
                  using the triple bar menu in the top-left corner <v-icon> mdi-menu</v-icon>.</p>
                  Configuration of the application is done with the triple dot menu in the top-right corner <v-icon> mdi-dots-vertical </v-icon>.
              </v-col>
            </v-row>
           </div>
          </v-main>
           </template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
      msg: 'SFB 1454 metadata database interface'
      // loggedIn: !this.$store.getters.isLoggedIn
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #f48990;
}
.override-class .v-input {
  display: inline-block;
  width: 150px;
}

</style>



// WEBPACK FOOTER //
// src/views/HomeComponent.vue